import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import {
  CustomEllipticalButton,
  CustomInput,
  CustomRectangleButton,
} from "Components/Form";
import { SnackBarContext } from "Context/SnackContext";
import { Invoices } from "Features/services/invoice.api";
import { getAccessToken } from "Features/slice/customer/customer.Slice";
import { useFormik } from "formik";
import { useAppDispatch, useAppSelector } from "Hooks/reduxHook";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Colors } from "Utils/colors";
import { LocalImage } from "Utils/images";
import { revertStatus } from "Utils/statusFormat";
import { orderStatuses } from "./InvoiceInformation";
import { Customer } from "Features/services/customer.api";
import { AnyARecord } from "dns";

interface InvoiceDetailModalProps {
  invoiceModal: boolean;
  closeInvoiceModal: () => void;
  invoiceDetail: any | null;
  setTrackStatusUpdated: any;
  notes?: any;
  setTrackDeleteNotes?: any;
}

const formatStatus = (status: string) => {
  return status.toLowerCase().replace(/ /g, "_");
};

const InvoiceDetailModal = ({
  invoiceDetail,
  closeInvoiceModal,
  invoiceModal,
  setTrackStatusUpdated,
  notes,
  setTrackDeleteNotes,
}: InvoiceDetailModalProps) => {
  const { handleSnackbar } = useContext(SnackBarContext);
  const dispatch = useAppDispatch();
  const { access_token } = useAppSelector((state: any) => state.customer);

  const [loading, setLoading] = useState<boolean>(false);

  const [value, setValue] = useState<number>(0);

  const [invoiceImg, setInvoiceImg] = useState<string | ArrayBuffer | null>("");
  const [noteText, setNoteText] = useState<string>("");

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isEmailManuallyChanged, setIsEmailManuallyChanged] = useState(false);

  const [showNotes, setShowNotes] = useState<boolean>(false);

  const validateEmail = (value: string) => {
    if (!value.includes("@") || !value.includes(".")) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  useEffect(() => {
    const defaultEmail = invoiceDetail?.Invoice?.BillEmail?.Address || "N/A";
    setEmail(defaultEmail);
    setIsEmailManuallyChanged(false);
  }, [invoiceDetail]);

  const handleEmailChange = (value: string) => {
    setEmail(value);
    validateEmail(value);
    setIsEmailManuallyChanged(true);
  };

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(getAccessToken());
  }, [dispatch]);


  const initialValues = {
    invoiceStatus: invoiceDetail?.Invoice?.invoiceStatus
      ? revertStatus(invoiceDetail.Invoice.invoiceStatus)
      : "",
  };

  const invoiceDetailForm = useFormik({
    initialValues,
    onSubmit: async (values, { setErrors }) => {
      debugger;
      const payload = {
        docNumber: invoiceDetail?.Invoice?.DocNumber,
        order_status: formatStatus(values.invoiceStatus),
      };

      try {
        const response = await Customer.instance.updateInvoiceStatus(payload);
        handleSnackbar(true, `Invoice updated successfully`, "success");
        setTrackStatusUpdated(true);
        closeInvoiceModal();
      } catch (error: any) {
        handleSnackbar(true, `${error.message}`, "error");
      }
    },
  });

  const handleSendInvoiceEmail = async () => {
    const payload = {
      access_token,
      invoiceId: invoiceDetail?.Invoice?.Id,
      ...(isEmailManuallyChanged && { emailAddr: email }),
    };

    try {
      setLoading(true);
      const response = await Invoices.instance.sendInvoiceEmail(payload);
      handleSnackbar(
        true,
        "Invoice has been successfully sent to the email",
        "success"
      );
    } catch (error: any) {
      handleSnackbar(true, error?.message || "An error occurred");
      console.error("Error:", error);
    } finally {
      closeInvoiceModal();
      setLoading(false);
    }
  };

  useEffect(() => {
    if (invoiceDetail?.Invoice?.invoiceStatus) {
      invoiceDetailForm.setFieldValue(
        "invoiceStatus",
        revertStatus(invoiceDetail.Invoice.invoiceStatus)
      );
    }
  }, [invoiceDetail?.Invoice?.invoiceStatus]);

  const handleAddNotes = () => {
    setShowNotes((prevShowNotes) => !prevShowNotes);
  };

  const handleCoverImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result;
        console.log("Base64 string:", base64String);
        if (base64String) {
          setInvoiceImg(base64String);
        }
      };

      reader.readAsDataURL(file);
    }
  };

  const handleCreateNotes = async () => {
    const payload = {
      invoice_Id: invoiceDetail?.Invoice?.Id,
      note_text: noteText,
      image: invoiceImg,
    };

    try {
      const response = await Invoices.instance.createNotes(payload);
      handleSnackbar(true, "Note has been created successfully", "success");
      closeInvoiceModal();
      setShowNotes(false);
      setNoteText("");
      setInvoiceImg(null);
    } catch (error: any) {
      handleSnackbar(true, error?.message || "An error occurred");
      console.error("Error:", error);
    }
  };

  const handleNoteDelete = async (noteId: any) => {
    try {
      const response = await Invoices.instance.deleteNotes(noteId);
      handleSnackbar(true, "Note has been deleted successfully", "success");
      setTrackDeleteNotes(true);
    } catch (error: any) {
      handleSnackbar(true, error?.message || "An error occurred");
      console.error("Error:", error);
    }
  };

  console.log("invoiceDetail---", invoiceDetail?.Invoice?.invoiceStatus);
  console.log("invoiceStatus---", invoiceDetailForm?.values?.invoiceStatus);
  

  console.log("")
  return (
    <Dialog
      open={invoiceModal}
      onClose={closeInvoiceModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="md"
    >
      <DialogTitle id="alert-dialog-title">Invoice Details</DialogTitle>

      <DialogContent sx={{ height: "63vh", overflowY: "auto" }}>

        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "50%",
                  marginBottom: "-16px",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "75px",
                  height: "75px",
                }}
              >
                <img
                  src={LocalImage.companyLogo}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  alt="Product"
                />
              </Box>

              <Box sx={{ marginLeft: "12px" }}>
                <Typography
                  variant="body1"
                  component={"body"}
                  fontSize={"12px"}
                >
                  Invoice Details
                </Typography>

                <Typography
                  variant="h4"
                  fontWeight={"bold"}
                  component={"h4"}
                  color={Colors.primary}
                  fontSize={"22px"}
                >
                  Fusion Link
                </Typography>
              </Box>
            </Box>


            <Box sx={{width: '33%', display: 'flex', alignItems: 'center', justifyContent: "space-between"}}>
              
              <Box>
              <CustomInput
                value={email}
                onChangeText={handleEmailChange}
                errorMessage={emailError}
                isError={!!emailError}
                required={true}
                // label="Email*"
                placeholder="example@example.com"
                size="small"
                containerStyle={{ flex: 0.8, marginTop: 1 }}
                labelStyle={{ fontWeight: 400, color: "#666666" }}
              />
            </Box>

            <Box>
              <CustomEllipticalButton
                buttonSize="xs"
                buttonHeight="sm"
                label={loading ? "Sending..." : "Send Email"}
                onBtnClick={handleSendInvoiceEmail}
                uppercase={false}
                variant="contained"
                buttonColor={Colors.secondary}
                labelColor={Colors.white}
              />
              </Box>

            </Box>

          </Box>
        </Box>

        <Box sx={{ border: `2px solid ${Colors.primary}` }} />
        <Box sx={{ border: `6px solid #A3CEDC` }} />

        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="invoice details tabs"
          centered
        >
          <Tab sx={{ fontWeight: "bold" }} label="Invoice Detail" />
          <Tab sx={{ fontWeight: "bold" }} label="Products" />
          <Tab sx={{ fontWeight: "bold" }} label="Billing Address" />
          <Tab sx={{ fontWeight: "bold" }} label="Shipping Address" />
          <Tab sx={{ fontWeight: "bold" }} label="Notes" />
        </Tabs>

        <Box sx={{ padding: 1, mt: 3 }}>
          {value === 0 && (
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItem: "center",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingBottom: 1,
                  }}
                >
                  <Box>
                    <Box component="span" fontWeight="bold">
                      Customer Name:
                    </Box>{" "}
                    {invoiceDetail?.Invoice?.CustomerRef?.name || "N/A"}
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingBottom: 1,
                  }}
                >
                  <Box>
                    <Box component="span" fontWeight="bold">
                      Created At:
                    </Box>{" "}
                    {moment(
                      invoiceDetail?.Invoice?.MetaData.CreateTime || "N/A"
                    ).format("h:mm a, Do MMMM YYYY")}
                  </Box>
                  <Box>
                    <Box component="span" fontWeight="bold">
                      Due Date:
                    </Box>{" "}
                    {invoiceDetail?.Invoice?.DueDate || "N/A"}
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingBottom: 1,
                  }}
                >
                  <Box>
                    <Box component="span" fontWeight="bold">
                      Doc Number:
                    </Box>{" "}
                    {invoiceDetail?.Invoice?.DocNumber || "N/A"}
                  </Box>

                  <Box>
                    <Box component="span" fontWeight="bold">
                      Total Amount:
                    </Box>{" "}
                    {invoiceDetail?.Invoice?.TotalAmt || "N/A"}
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingBottom: 1,
                  }}
                >
                  <Box>
                    <Box component="span" fontWeight="bold">
                      Currency:
                    </Box>{" "}
                    {invoiceDetail?.Invoice?.CurrencyRef?.value || "N/A"}
                  </Box>

                  <Box>
                    <Box component="span" fontWeight="bold">
                      Email Status:
                    </Box>{" "}
                    {invoiceDetail?.Invoice?.EmailStatus || "N/A"}
                  </Box>

                  <Box>
                    <Box sx={{ flex: 1 }}>
                      <InputLabel
                        sx={{
                          fontSize: 12,
                          color: "#666666",
                          fontWeight: 700,
                        }}
                      >
                        Invoice Status
                      </InputLabel>

                      <Select
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        value={invoiceDetailForm?.values?.invoiceStatus || ""}
                        inputProps={{ "aria-label": "Without label" }}
                        onChange={(e) => {
                          invoiceDetailForm.setFieldValue(
                            "invoiceStatus",
                            e.target.value
                          );
                          console.log("New invoiceStatus--", e.target.value);
                        }}
                        fullWidth
                        size="small"
                        sx={{ mt: 0.5, pb: 0.2, height: "32px" }}
                      >
                        {orderStatuses.map((status) => (
                          <MenuItem key={status} value={status}>
                            {status}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}

          {value === 1 && (
            <Box>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ backgroundColor: "#e6f1f5" }}>
                        Product Name
                      </TableCell>
                      <TableCell sx={{ backgroundColor: "#e6f1f5" }}>
                        Unit Price
                      </TableCell>
                      <TableCell sx={{ backgroundColor: "#e6f1f5" }}>
                        Quantity
                      </TableCell>
                      <TableCell sx={{ backgroundColor: "#e6f1f5" }}>
                        Amount
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoiceDetail?.Invoice?.Line?.filter(
                      (product: any) => product?.Id
                    ).map((product: any) => (
                      <TableRow key={product.Id}>
                        <TableCell>
                          {product?.SalesItemLineDetail?.ItemRef?.name || "N/A"}
                        </TableCell>
                        <TableCell>
                          {product?.SalesItemLineDetail?.UnitPrice || "N/A"}
                        </TableCell>
                        <TableCell>
                          {product?.SalesItemLineDetail?.Qty || "N/A"}
                        </TableCell>
                        <TableCell>{product?.Amount || "N/A"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Box
                  sx={{
                    mx: 4,
                    mt: 2,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box component="span" fontWeight="bold">
                    Total Amount:
                  </Box>{" "}
                  {invoiceDetail?.Invoice?.TotalAmt || "N/A"}
                </Box>
              </TableContainer>
            </Box>
          )}

          {value === 2 && (
            <Box>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="span"
                    fontWeight="bold"
                    sx={{ marginRight: 1 }}
                  >
                    Address:
                  </Box>
                  {invoiceDetail?.Invoice?.BillAddr?.Line1 || "N/A"}
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="span"
                    fontWeight="bold"
                    sx={{ marginRight: 1 }}
                  >
                    City:
                  </Box>
                  {invoiceDetail?.Invoice?.BillAddr?.City || "N/A"}
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="span"
                    fontWeight="bold"
                    sx={{ marginRight: 1 }}
                  >
                    Country Code:
                  </Box>
                  {invoiceDetail?.Invoice?.BillAddr?.CountrySubDivisionCode ||
                    "N/A"}
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="span"
                    fontWeight="bold"
                    sx={{ marginRight: 1 }}
                  >
                    Postal Code:
                  </Box>
                  {invoiceDetail?.Invoice?.BillAddr?.PostalCode || "N/A"}
                </Box>
              </Box>
            </Box>
          )}

          {value === 3 && (
            <Box>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="span"
                    fontWeight="bold"
                    sx={{ marginRight: 1 }}
                  >
                    Address:
                  </Box>
                  {invoiceDetail.Invoice.ShipAddr.Line1 || "N/A"}
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="span"
                    fontWeight="bold"
                    sx={{ marginRight: 1 }}
                  >
                    City:
                  </Box>
                  {invoiceDetail.Invoice.ShipAddr.City || "N/A"}
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="span"
                    fontWeight="bold"
                    sx={{ marginRight: 1 }}
                  >
                    Country Code:
                  </Box>
                  {invoiceDetail.Invoice.ShipAddr.CountrySubDivisionCode ||
                    "N/A"}
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    component="span"
                    fontWeight="bold"
                    sx={{ marginRight: 1 }}
                  >
                    Postal Code:
                  </Box>
                  {invoiceDetail.Invoice.ShipAddr.PostalCode || "N/A"}
                </Box>
              </Box>
            </Box>
          )}

          {value === 4 && (
            <Box>
              <TableContainer sx={{ maxHeight: "200px", overflowY: "auto" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ backgroundColor: "#e6f1f5" }}>
                        Notes
                      </TableCell>
                      <TableCell sx={{ backgroundColor: "#e6f1f5" }}>
                        Image
                      </TableCell>
                      <TableCell sx={{ backgroundColor: "#e6f1f5" }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {notes.length > 0 ? (
                      notes.map((note: any) => (
                        <TableRow key={note.id}>
                          <TableCell>{note.note_text || "N/A"}</TableCell>
                          <TableCell>
                            {note.image && (
                              <img
                                src={note.image}
                                alt="Note"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "5px",
                                }}
                              />
                            )}
                          </TableCell>
                          <TableCell
                            sx={{ color: "red", cursor: "pointer" }}
                            onClick={() => handleNoteDelete(note.id)}
                          >
                            Delete
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={3} align="center">
                          No notes available
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box sx={{ mt: 2 }}>
                <CustomEllipticalButton
                  buttonSize="xs"
                  buttonHeight="sm"
                  label={showNotes ? "Hide Notes" : "Add Notes"}
                  onBtnClick={handleAddNotes}
                  uppercase={false}
                  variant="contained"
                  buttonColor={Colors.secondary}
                  labelColor={Colors.white}
                />
              </Box>

              {showNotes && (
                <Box mt={2}>
                  <TextField
                    value={noteText}
                    onChange={(e) => setNoteText(e.target.value)}
                    label="Write your notes"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                    sx={{ mb: 2 }}
                  />

                  <Grid container spacing={2} alignItems="center">
                    <Grid item md={6} xs={12}>
                      <TextField
                        type="file"
                        id="invoiceImg"
                        label="Cover Image"
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        onChange={handleCoverImageChange}
                      />
                    </Grid>

                    <Grid item md={6} xs={12}>
                      {invoiceImg && (
                        <img
                          src={invoiceImg as string}
                          alt="Uploaded Invoice"
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "5px",
                          }}
                        />
                      )}
                    </Grid>
                  </Grid>

                  <Box sx={{ mt: 2 }}>
                    <CustomEllipticalButton
                      buttonSize="xs"
                      buttonHeight="sm"
                      label={"Submit Note"}
                      onBtnClick={handleCreateNotes}
                      uppercase={false}
                      variant="contained"
                      buttonColor={Colors.secondary}
                      labelColor={Colors.white}
                    />
                  </Box>
                </Box>
              )}
            </Box>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "center",
            mb: 2,
          }}
        >
          <CustomRectangleButton
            label={"close"}
            variant={"outlined"}
            labelColor="#FFAA2A"
            buttonContainerStyle={{
              border: "1px solid #FFAA2A",
              fontWeight: 700,
            }}
            onBtnClick={closeInvoiceModal}
            uppercase={false}
            buttonnSize={"sm"}
          />

          <CustomRectangleButton
            label={"Update"}
            variant={"outlined"}
            labelColor="#fff"
            buttonColor="#FFAA2A"
            buttonContainerStyle={{
              border: "1px solid #FFAA2A",
              fontWeight: 700,
              marginLeft: "20px",
            }}
            onBtnClick={() => {
              invoiceDetailForm.handleSubmit();
            }}
            uppercase={false}
            buttonnSize={"sm"}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default InvoiceDetailModal;
